import Vue from "vue";
import { getUITranslation } from "../utils/get_ui_translation";
import { FreeFormInput, FreeFormInputComponent } from "./inputs/free_form_input";
import { RadioFormInput, RadioFormInputComponent } from "./inputs/radio_form_input";
import { CheckboxFormInput, CheckboxFormInputComponent } from "./inputs/checkbox_form_input";
import { MatrixFormInput, MatrixFormInputComponent } from "./inputs/matrix_form_input";
import { RatingFormInput, RatingFormInputComponent } from "./inputs/rating_form_input";
import { ScoreFormInput, ScoreFormInputComponent } from "./inputs/score_form_input";
import { saveAsTemplateModal } from "./save_template_modal";
import { VueRenderMixin } from "../framework/vue_render_mixin";
import * as Dialog from "../framework/dialog";
import autosize from "autosize";

/* global form, highlight */

let viewmodel = null;
let BACKUP_NAME = "form_temp_answers";

document.addEventListener("DOMContentLoaded", function () {
  // Initialize a Vue.js viewmodel
  //---------------------------------------
  if (document.querySelector("#js-form-form")) {
    viewmodel = new Vue({
      mixins: [VueRenderMixin(["inputs"])],
      el: "#js-form-form",
      data: {
        inputs: form.inputs,
        title: form.title,
        inserting_index: null,
      },
      methods: {
        addFreeInput: function (index) {
          addInput(new FreeFormInput(), index);
        },
        addRadioInput: function (index) {
          addInput(new RadioFormInput(), index);
        },
        addCheckboxInput: function (index) {
          addInput(new CheckboxFormInput(), index);
        },
        addMatrixInput: function (index) {
          addInput(new MatrixFormInput(), index);
        },
        addRatingInput: function (index) {
          addInput(new RatingFormInput(), index);
        },
        addScoreInput: function (index) {
          addInput(new ScoreFormInput(), index);
        },
        addProgramInput: function (index) {
          addProgramInput(index);
        },
        moveUp: onMoveUp,
        moveDown: onMoveDown,
        insert: onInsert,
        saveInLibrary: onSaveInLibrary,
        remove: onRemoveInput,
        onTraineeAnswer: onTraineeAnswer,
      },
      components: {
        free: FreeFormInputComponent,
        radio: RadioFormInputComponent,
        checkbox: CheckboxFormInputComponent,
        matrix: MatrixFormInputComponent,
        rating: RatingFormInputComponent,
        score: ScoreFormInputComponent,
      },
    });

    reloadBackup();
  }
});

//------------------------------------------------------------------------------
// addInput
//------------------------------------------------------------------------------
function addInput(obj, index) {
  if (typeof index === "number") {
    viewmodel.inputs.splice(index, 0, obj);
  } else {
    viewmodel.inputs.push(obj);
  }
  viewmodel.inserting_index = null;
}

function addProgramInput(index) {
  let goals = window.program_goals;
  if (window.template_mode) {
    goals = [{ text: "" }];
  }

  if (goals) {
    // Programs
    addInput(
      new MatrixFormInput(
        {
          topic: getUITranslation("À ce jour, considérez-vous maîtriser les objectifs du programme\u00A0?"),

          question: "",
          answers: _.map(goals, (g) => ({ text: g.text })),
          levels: [
            { text: getUITranslation("Pas du tout") },
            { text: getUITranslation("Insuffisamment") },
            { text: getUITranslation("En partie") },
            { text: getUITranslation("Totalement") },
          ],
        },
        "program"
      ),
      index
    );

    // Program levels
    for (var goal of goals) {
      addInput(
        new ScoreFormInput(
          {
            question: `${getUITranslation("Évaluez vos compétences : ")}${goal.text}`,
          },
          "program_level"
        ),
        index
      );
    }
  }
}

//------------------------------------------------------------------------------
// onRemoveInput
//------------------------------------------------------------------------------
function onRemoveInput(input) {
  this.inputs = _.without(this.inputs, input);
}

//------------------------------------------------------------------------------
// onMoveUp, onMoveDown
//------------------------------------------------------------------------------
function onMoveUp(index) {
  move.call(this, index, index - 1);
}

function onMoveDown(index) {
  move.call(this, index, index + 1);
}

function move(index, nextIndex) {
  if (0 <= nextIndex && nextIndex < this.inputs.length) {
    let removed = this.inputs[index];
    this.inputs.splice(index, 1);
    this.inputs.splice(nextIndex, 0, removed);
    highlight(nextIndex);
    setTimeout(function () {
      autosize.update($(".autoresize"));
    }, 0);
  }
}

//------------------------------------------------------------------------------
// onInsert
//------------------------------------------------------------------------------
function onInsert(index) {
  this.inserting_index = index;
}

//------------------------------------------------------------------------------
// onAnswerForm
//------------------------------------------------------------------------------
function onAnswerForm() {
  const elDataset = viewmodel.$el.dataset;

  let trainee_answers = {};
  for (var child of viewmodel.$children) {
    trainee_answers[child.input.id] = child.trainee_answer;
  }

  ajax({
    type: "POST",
    url: elDataset.action,
    data: { answers: JSON.stringify(trainee_answers) },
    error: function () {
      console.error("Error, sent: ", { answers: trainee_answers });
    },
    success: function (data) {
      if (data.success) {
        flushBackup();
        window.location.href = data.redirect;
      } else {
        console.error(data.error);
        Dialog.alertError(getUITranslation("Erreur lors de l'enregistrement"), data.error).then(function () {
          if (data.redirect) window.location.href = data.redirect;
        });
      }
    },
  });
}

//------------------------------------------------------------------------------
// onSave
//------------------------------------------------------------------------------
function onSaveForm(form) {
  doSave(async function (success, error) {
    if (success && form) {
      form.submit();
    } else {
      console.error(error);
      Dialog.alertError(getUITranslation("Erreur lors de l'enregistrement"), error);
    }
  });
}

function doSave(done) {
  const elDataset = viewmodel.$el.dataset;

  let json = {
    title: viewmodel.title,
    inputs: viewmodel.inputs,
    schema_version: "2.0",
  };

  ajax({
    type: "PUT",
    url: elDataset.action,
    data: { form: JSON.stringify(json) },
    error: function () {
      console.error("error");
    },
    success: function (data) {
      done(data.success, data.error);
    },
  });
}

//------------------------------------------------------------------------------
// onSaveInLibrary
//------------------------------------------------------------------------------
function onSaveInLibrary(e) {
  e.preventDefault();

  doSave(() => {
    saveAsTemplateModal({
      createTemplate: (data) => saveDefaultForm("POST", window.create_template_path, data),
      updateTemplate: (templateId) => saveDefaultForm("PUT", window.update_template_path.replace("-1", templateId), {}),
    });
  });
}

const saveDefaultForm = (method, url, data) => {
  ajax({
    type: method,
    url: url,
    data: data,
    error: function () {
      console.error("error");
    },
    success: function (data) {
      if (data.success) {
        Dialog.alertInfo("", getUITranslation("Ce formulaire est enregistré dans votre bibliothèque de modèles.")).then(() => {
          if (data.templates) window.location.reload();
        });
      } else {
        Dialog.alertError(getUITranslation("Erreur"), data.error);
      }
    },
  });
};

//------------------------------------------------------------------------------
// onTraineeAnswer
//------------------------------------------------------------------------------
function onTraineeAnswer(subvm) {
  backup();
  $(document).trigger("form_input_answered", subvm.input.id);
}

//------------------------------------------------------------------------------
// backup during answering
//------------------------------------------------------------------------------
function backup() {
  if (window.backup_form == false) {
    flushBackup();
    return;
  }
  if (viewmodel) {
    let answers = [];
    for (var child of viewmodel.$children) {
      answers.push(child.trainee_answer);
    }
    let backup = {
      formId: window.form.id,
      answers: answers,
    };
    localStorage.setItem(BACKUP_NAME, JSON.stringify(backup));
  }
}

function reloadBackup() {
  if (window.backup_form == false) {
    flushBackup();
    return;
  }
  let backupJson = localStorage.getItem(BACKUP_NAME);
  if (backupJson) {
    let backup = JSON.parse(backupJson);
    if (backup.formId == window.form.id) {
      for (var i = 0; i < viewmodel.$children.length; ++i) {
        let child = viewmodel.$children[i];
        let answer = backup.answers[i];
        if (answer != "") child.trainee_answer = backup.answers[i];
      }
    }
  }
}

function flushBackup() {
  localStorage.removeItem(BACKUP_NAME);
}

//------------------------------------------------------------------------------
// Exported functions (to allow Vue event outside of Vue)
//------------------------------------------------------------------------------

function saveOrAnswerForm(args) {
  const elDataset = viewmodel.$el.dataset;
  if (elDataset.viewMode === "edit") {
    onSaveForm(args);
  } else {
    onAnswerForm();
  }
}

window.formFormFunctions = {
  saveOrAnswerForm: saveOrAnswerForm,
};
